import "bootstrap/dist/css/bootstrap.css"
// Pinia storage
import { createPinia } from "pinia";
// Query
import { VueQueryPlugin } from '@tanstack/vue-query'
import { queryClient } from '@/queryClient.js'
// Tables
// https://hc200ok.github.io/vue3-easy-data-table-doc/props/common-props.html
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
// Graph
import VNetworkGraph from "v-network-graph"
import "v-network-graph/lib/style.css"
// Routing
import router from './router/index.js'

import { createApp } from 'vue'
import App from './App.vue'
import { ref } from 'vue'
import { EmptyNavSection } from './customNavSection'


const app = createApp(App)

// Use v-network-graph
app.use(VNetworkGraph)
// Use router
app.use(router)

// Developer account id
app.provide('developerId', '64f6f008dd9de0bfc8d3aaa2')
// Provide height of header for all views
app.provide('headerHeight', '48px')
// Provide Station and Post Icons
app.provide('stationSvgPath', 'M1.5 0A1.5 1.5 0 0 0 0 1.5v2A1.5 1.5 0 0 0 1.5 5h13A1.5 1.5 0 0 0 16 3.5v-2A1.5 1.5 0 0 0 14.5 0h-13zm1 2h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm9.927.427A.25.25 0 0 1 12.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0l-.396-.396zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z')
app.provide('postSvgPath', 'M7 1.414V4H2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5v6h2v-6h3.532a1 1 0 0 0 .768-.36l1.933-2.32a.5.5 0 0 0 0-.64L13.3 4.36a1 1 0 0 0-.768-.36H9V1.414a1 1 0 0 0-2 0zM12.532 5l1.666 2-1.666 2H2V5h10.532z')

// Provide reactive empty custom navigation
const customNav = ref(new EmptyNavSection())
app.provide('customNavSection', customNav)

// Pinia
app.use(createPinia())
//
app.use(VueQueryPlugin, { queryClient })

// Add table component
app.component('EasyDataTable', Vue3EasyDataTable);

//
app.mount('#app')
